import { action } from 'satcheljs/lib/legacy';
import { default as getNotesSDK } from '../utils/getNotesSDK';
export default action('changeNotesLanguage')(function changeNotesLanguage(langCode: string) {
    getNotesSDK().changeLanguage(langCode);
});
